import React from 'react';
import styled from 'styled-components';
import {
  CpBody03Secondary,
  CpHeading03Primary,
  CpHeading01Primary,
  CpBody01Secondary,
  CpBody03Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpMetricsVariantWidgetProps } from '../types';
import { CpMetricsSectionWrapper } from './metrics-grid';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  overflow-y: hidden;
  gap: var(--cp-spacing-08);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Description = styled(CpBody03Secondary)`
  margin-bottom: 0;
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--cp-spacing-06);
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const MetricsCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--cp-spacing-06);
  padding: var(--cp-spacing-08) var(--cp-spacing-06);
  border: 1px solid var(--Border-border-subtle, rgba(0, 0, 0, 0.12));
  background-color: white;

  @media (max-width: 480px) {
    padding: var(--cp-spacing-05);
    gap: 0;
  }
`;

const MetricValue = styled(CpHeading01Primary)`
  margin-bottom: 0;
`;

const MetricDescription = styled(CpBody01Secondary)`
  margin-bottom: 0;
`;

const MetricTitle = styled(CpBody03Primary)`
  margin-bottom: 0;
`;

const MetricDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);
`;

export const CpMetricsCardGrid: React.FC<CpMetricsVariantWidgetProps> = ({
  disabled,
  data,
  widget,
}) => {
  const background = useGetBackground(widget);

  return (
    <CpMetricsSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={background}
    >
      <Wrapper>
        <TitleWrapper>
          <Title autoAdjustColor>{data.title}</Title>
          <Description autoAdjustColor>{data.description}</Description>
        </TitleWrapper>
        <MetricsGrid>
          {data?.metricsItems?.map((metric) => (
            <MetricsCard>
              <MetricValue>{metric?.metric}</MetricValue>
              <MetricDetails>
                <MetricTitle>{metric.title}</MetricTitle>
                <MetricDescription>{metric.description}</MetricDescription>
              </MetricDetails>
            </MetricsCard>
          ))}
        </MetricsGrid>
      </Wrapper>
    </CpMetricsSectionWrapper>
  );
};
